// Generated by extract-enums.sh — do not edit manually

export enum FinancingTypeEnum {
  CASH = "cash",

  ORTHO_FI = "ortho_fi",
}

export enum SupplierEnum {
  INVISALIGN = "invisalign",

  ANGELALIGN = "angelalign",
}
